/**
 * 製品製作図用規格項目リビジョン エンティティ
 */
import { isNud } from '@/utilities/typing';
import ProductSubgroupRevision from '@/models/entities/product-subgroup-revision';
import ProductProductionSpecLabel from '@/models/entities/product-production-spec-label';
import SpecLabel from '@/models/entities/spec-label';
import SpecPrefix from '@/models/entities/spec-prefix';
import SpecSuffix from '@/models/entities/spec-suffix';

class ProductProductionSpecLabelRevision {
    product_production_spec_label_revision_id;
    product_subgroup;
    production_spec_label;
    spec_label;
    spec_prefix;
    spec_suffix;
    priority;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.product_production_spec_label_revision_id = properties.product_production_spec_label_revision_id ?? null;
        this.product_subgroup = new ProductSubgroupRevision(properties.product_subgroup);
        this.production_spec_label = new ProductProductionSpecLabel(properties.production_spec_label);
        this.spec_label = new SpecLabel(properties.spec_label);
        this.spec_prefix = new SpecPrefix(properties.spec_prefix);
        this.spec_suffix = new SpecSuffix(properties.spec_suffix);
        this.priority = properties.priority ?? null;
    }
}

export default ProductProductionSpecLabelRevision;
